"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classNames = require("classnames");
var react_apollo_1 = require("react-apollo");
var graphql_tag_1 = require("graphql-tag");
var react_tracking_1 = require("react-tracking");
var I18n = require("i18n-js");
var condition_display_1 = require("./condition_display");
var price_with_shipping_1 = require("./price_with_shipping");
var seller_info_1 = require("./seller_info");
var core_link_1 = require("./core_link");
var rql_1 = require("../rql");
var tracker_1 = require("../tracker");
var add_to_cart_button_1 = require("./add_to_cart_button");
var create_offer_button_1 = require("../offers/create_offer_button");
var watch_badge_1 = require("./watch_badge");
var user_context_provider_1 = require("./user_context_provider");
var url_helpers_1 = require("../url_helpers");
var DIGITAL_LISTING_UUID = 'e71b6e43-7217-4746-b4e3-64bf708a2664';
function PlaceholderCard() {
    return (React.createElement("div", { className: "listing-row-card listing-row-card--placeholder" },
        React.createElement("div", { className: "listing-row-card__inner" },
            React.createElement("div", { className: "listing-row-card__main" },
                React.createElement("div", { className: "listing-row-card__info-and-image" },
                    React.createElement("div", { className: "listing-row-card__image" },
                        React.createElement("div", { className: "listing-row-card__image__inner" })))))));
}
function buildComponentName(data, props) {
    return props.bumped ? data.componentName + "BumpRow" : data.componentName;
}
var ListingRowCard = /** @class */ (function (_super) {
    tslib_1.__extends(ListingRowCard, _super);
    function ListingRowCard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListingRowCard.prototype.isDigitalListing = function () {
        if (!this.props.listing.categoryUuids) {
            return false;
        }
        return this.props.listing.categoryUuids.includes(DIGITAL_LISTING_UUID);
    };
    ListingRowCard.prototype.listingUrl = function () {
        return url_helpers_1.ITEM_WITH_SLUG_ROUTE.expand({
            slug: this.props.listing.slug,
            id: this.props.listing.id,
        });
    };
    ListingRowCard.prototype.renderConditionDisplay = function () {
        if (this.isDigitalListing())
            return null;
        return (React.createElement("div", { className: "listing-row-card__condition" },
            React.createElement(condition_display_1.default, { slug: this.props.listing.condition.conditionSlug, displayName: this.props.listing.condition.displayName })));
    };
    ListingRowCard.prototype.hasDiscount = function () {
        return !!this.props.listing.pricing.originalPrice;
    };
    ListingRowCard.prototype.renderMetadata = function () {
        if (this.props.displayMetadataAsOffer) {
            return (React.createElement("div", { itemProp: "offers", itemScope: true, itemType: "http://schema.org/Offer" },
                React.createElement("meta", { itemProp: "priceCurrency", content: this.props.listing.pricing.buyerPrice.currency }),
                React.createElement("meta", { itemProp: "price", content: "" + this.props.listing.pricing.buyerPrice.amountCents / 100 }),
                React.createElement("meta", { itemProp: "availability", content: "http://schema.org/InStock" }),
                React.createElement("meta", { itemProp: "url", content: "http://reverb.com/" + this.listingUrl() }),
                React.createElement("meta", { itemProp: "gtin14", content: this.props.listing.upc })));
        }
        return null;
    };
    ListingRowCard.prototype.getImageStyle = function () {
        if (!this.props.listing)
            return null;
        return {
            style: {
                backgroundImage: "url('" + this.props.listing.images[0].source + "')",
            },
        };
    };
    ListingRowCard.prototype.renderSellerInfo = function () {
        return (React.createElement(seller_info_1.default, { shop: this.props.data.shop }));
    };
    ListingRowCard.prototype.renderOfferButton = function () {
        var listing = this.props.listing;
        if (listing.listingType !== rql_1.core_apimessages_Listing_ListingType.MAKE_AN_OFFER)
            return null;
        return (React.createElement(create_offer_button_1.default, { listingId: listing.id, listing: listing, onOfferSuccess: this.props.onOfferSuccess, position: this.props.position, parentComponentName: buildComponentName(this.props.tracking.getTrackingData(), this.props) }));
    };
    ListingRowCard.prototype.render = function () {
        if (!this.props.listing) {
            return React.createElement(PlaceholderCard, null);
        }
        var classes = classNames('listing-row-card', { 'listing-row-card--software': this.isDigitalListing() }, { 'listing-row-card--discounted': this.hasDiscount() }, { 'listing-row-card--bumped': this.props.bumped });
        return (React.createElement("div", { className: classes },
            React.createElement(core_link_1.default, { className: "listing-row-card__inner", to: this.listingUrl(), entityId: this.props.listing.id, position: this.props.position },
                this.renderMetadata(),
                React.createElement("div", { className: "listing-row-card__main" },
                    React.createElement("div", { className: "listing-row-card__info-and-image" },
                        React.createElement("div", { className: "listing-row-card__image" },
                            React.createElement("div", tslib_1.__assign({ className: "listing-row-card__image__inner" }, this.getImageStyle()))),
                        React.createElement("div", { className: "listing-row-card__info" },
                            React.createElement("h4", { className: "listing-row-card__title" },
                                this.props.listing.title,
                                React.createElement("div", { className: "mt-half opacity-60 size-60 weight-normal" }, this.props.listing.bumpInfo &&
                                    I18n.t('discovery.bumpInfo', tslib_1.__assign({}, this.props.listing.bumpInfo)))),
                            this.renderSellerInfo())),
                    React.createElement("div", { className: "listing-row-card__pricing" },
                        React.createElement("div", { className: "listing-row-card__pricing__amount" },
                            React.createElement(price_with_shipping_1.default, { listing: this.props.listing }),
                            this.renderConditionDisplay()),
                        React.createElement("div", { className: "ml-2 align-center" },
                            React.createElement(add_to_cart_button_1.default, { listing: this.props.listing, className: "listing-row-card__pricing__amount", position: this.props.position, parentComponentName: buildComponentName(this.props.tracking.getTrackingData(), this.props) }),
                            React.createElement("div", { className: "mt-half" }, this.renderOfferButton()),
                            React.createElement("div", { className: "mt-half" },
                                React.createElement(watch_badge_1.default, { listing: this.props.listing, position: this.props.position, parentComponentName: buildComponentName(this.props.tracking.getTrackingData(), this.props), includeText: true }))))))));
    };
    ListingRowCard = tslib_1.__decorate([
        react_tracking_1.default(function (props) {
            return {
                mParticleInteraction: function (data) { return tracker_1.buildListingClickEvent(tslib_1.__assign(tslib_1.__assign({}, data), { componentName: buildComponentName(data, props) }), props.listing, {}); },
            };
        })
    ], ListingRowCard);
    return ListingRowCard;
}(React.Component));
exports.ListingRowCard = ListingRowCard;
var connect = react_apollo_1.graphql(graphql_tag_1.default(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    query Commons_ListingRowCard_ShopDetails(\n      $uuid: String\n    ){\n      shop(\n        input: {uuid: $uuid}\n      ) {\n        name\n        slug\n        preferredSeller\n        quickShipper\n        quickResponder\n        address {\n          displayLocation\n        }\n        user {\n          feedbackSummary {\n            rollingRatingPercentage\n            receivedCount\n          }\n        }\n      }\n    }\n  "], ["\n    query Commons_ListingRowCard_ShopDetails(\n      $uuid: String\n    ){\n      shop(\n        input: {uuid: $uuid}\n      ) {\n        name\n        slug\n        preferredSeller\n        quickShipper\n        quickResponder\n        address {\n          displayLocation\n        }\n        user {\n          feedbackSummary {\n            rollingRatingPercentage\n            receivedCount\n          }\n        }\n      }\n    }\n  "]))), {
    skip: function (ownProps) { return !ownProps.listing; },
    options: function (ownProps) {
        return {
            ssr: false,
            variables: {
                uuid: ownProps.listing.shopUuid,
            },
        };
    },
});
exports.default = user_context_provider_1.withUserContext(connect(ListingRowCard));
var templateObject_1;
//# sourceMappingURL=listing_row_card.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/listing_row_card.js
// module id = XD+2
// module chunks = 0 1 2 3 4 6 8 11 12 13 20